<template>
  <div>
    <top :text="titletext"></top>
    <div class="block">
      <el-carousel trigger="click" height="150px" indicator-position="outside">
        <el-carousel-item v-for="item in res.banners" :key="item.id">
          <img style="width:100%; height:100%;" :src="item.cover" alt="" @click="toLink(item.url)">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="title">
      ·&nbsp;研学课程&nbsp;·
    </div>
    <div v-if="res.lectures">
      <div v-for="item in res.lectures" :key="item.id">
        <div class="picture" @click="toDetail(item.id)">
          <img :src="item.thumbnail" alt="">
          <div>
            <span class="signUp" v-if="item.available">报名中</span>
            <span class="unSignUp" v-else>已结束</span>
            {{item.title}}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="noneClass">
      目前没有课程
    </div>
    <div class="right">
      <div>版权所有©2021 朗锐科技 粤ICP备14028656号</div>
    </div>
    <div style="height: 70px;"></div>
    <sidebar :selected="select"></sidebar>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import top from '../components/Top.vue'
import http from '../utils/http'

export default {
  components: { Sidebar, top },
  name: 'IndexPage',
  data () {
    return {
      titletext: '新华研学',
      select: 1,
      res: Object
    }
  },
  created () {
    http['get']('home').then((res) => { this.res = res })
  },
  methods: {
    toDetail: function (id) {
      this.$router.push({name: 'courseDetail', query: {id: id}})
    },
    toLink (url) {
      if (url) {
        window.location.href = url
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  width: 100%;
  height: 68px;
  font-family: "PingFang-SC-Medium";
  font-size: 20px;
  color: #000;
  line-height: 68px;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}
.picture {
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  margin: 10px 10px 0 10px;
}
.picture img{
  width: 100%;
  border-radius: 10px 10px 0 0;
}
.picture div{
  height: 50px;
  text-align: left;
  line-height: 50px;
  font-family: "PingFang-SC-Medium";
  color: #333;
  margin-left: 5px;
}
.right {
  color: #bbb;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: scale(0.8)
}
.signUp {
  font-size: 12px;
  color: #fff;
  background: rgb(0, 137, 25);
  padding: 3px;
  border-radius: 3px;
}
.unSignUp {
  font-size: 12px;
  color: #fff;
  background: #999;
  padding: 3px;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/class/IndexPage.vue